module.exports = __webpack_public_path__ + "img/flag-UK.a8144d77.png";